function newSorting() {
  const sortBtn = document.querySelector(".custom_select_label");
  if (!sortBtn) return;

  if (sortBtn.dataset.sortBound === "1") return;
sortBtn.dataset.sortBound = "1";

  const sortSelect = document.querySelector(".custom_select");
  const sortByList = document.getElementById("SortBy");
  const listItems = sortByList ? sortByList.getElementsByTagName("li") : [];
  const loader = document.querySelector(".loading-spinner");
  const productGrid = document.getElementById("product-grid");

  if (!productGrid) return;

  // Get the correct section id from data-id
  const sectionId = productGrid.getAttribute("data-id");

  // Toggle dropdown
sortBtn.addEventListener("click", function () {
  if (!sortSelect) return;
  sortSelect.classList.toggle("hidden");
});

  Array.from(listItems).forEach((item) => {
    item.addEventListener("click", function () {
      const sortByValue = this.getAttribute("value");
      updateSort(this);
      updateURLParameter("sort_by", sortByValue);
      fetchSortedProducts(sortByValue);
    });
  });

  // function updateSort(selectedItem) {
  //   Array.from(listItems).forEach((item) => item.classList.remove("active"));
  //   selectedItem.classList.add("active");
  //   sortSelect.classList.add("hidden");

  //   const sortBtnLabel = document.querySelector(".custom_select_label span");
  //   if (sortBtnLabel) {
  //     sortBtnLabel.textContent = selectedItem.textContent;
  //   }
  // }
function updateSort(selectedItem) {
  document.querySelectorAll("#SortBy li").forEach((item) => {
    item.classList.remove("active");
    item.removeAttribute("aria-selected");
  });

  selectedItem.classList.add("active");
  selectedItem.setAttribute("aria-selected", "true");

  const updateSrt = document.getElementById("sort_by");
  if (updateSrt) updateSrt.textContent = selectedItem.textContent.trim();

  document.querySelector(".custom_select")?.classList.add("hidden");
}

  function updateURLParameter(param, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(param, value);
    history.pushState({}, "", url);
  }

  function fetchSortedProducts(sortByValue) {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", sortByValue);
    url.searchParams.set("section_id", sectionId); // ✨ using data-id for section_id

    if (loader) loader.classList.remove("hidden");

    fetch(url.toString(), { method: "GET" })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newGrid = doc.getElementById("product-grid");
        if (newGrid) {
  productGrid.innerHTML = newGrid.innerHTML;

  // audit M15 — dispatch FIRST, before active_colors(): the re-init bus must run on
  // virgin cards. Running it after active_colors wiped the DOM under the swipers that
  // active_colors had just created, leaving live-looking zombie instances that blocked
  // re-init (green flags, dead hover). Hover handlers resolve the instance at hover-time,
  // so the fresh swipers created by active_colors below are picked up correctly.
  try {
    document.dispatchEvent(new CustomEvent("collection:loadmore:appended", { detail: { source: "sort" } }));
  } catch (e) {}

  colorVariantSwatches();
  filtersSwiperFunction();
  if (typeof active_colors === "function") active_colors();
  bindSlideDotsEvents();

  // quickAddSizeInputsFunction();
}
      })
      .catch((error) => {
        console.error("Error fetching sorted products:", error);
      })
      .finally(() => {
        if (loader) loader.classList.add("hidden");
      });
  }
}


// ✅ **Fix for UI Selection and Dropdown Handling**
// function updateSort(selectedItem) {
//   const sortByList = document.getElementById("SortBy");

//   // Remove "aria-selected" from all items
//   document
//     .querySelectorAll("#SortBy li")
//     .forEach((item) => item.removeAttribute("selected"));

//   // Set "aria-selected" on the clicked item
//   selectedItem.setAttribute("selected", "selected");

//   // Update label with selected value
//   const selectedText = selectedItem.textContent.trim();
//   const updateSrt = document.getElementById("sort_by");

//   if (updateSrt) {
//     updateSrt.textContent = selectedText;
//   }

//   // Hide dropdown after selection
//   document.querySelector(".custom_select")?.classList.add("hidden");
// }

newSorting();

function colorVariantSwatches() {
  var collectionGrid =
    document.querySelector(".collection-page-grid") ||
    document.querySelector(".template-search__results .product-grid");
  if (collectionGrid) {
    var colProducts = collectionGrid.querySelectorAll(".grid__item");

    colProducts.forEach(function (singleProduct) {
      if (singleProduct.dataset.colorSwatchesBound === "1") return;
  singleProduct.dataset.colorSwatchesBound = "1";
      var pColors = singleProduct.querySelectorAll(".color_product_main");
      pColors.forEach(function (singleColor) {
        singleColor.addEventListener("click", function () {
          return; // audit H2 — duplicate swatch handler disabled; custom.js updateSelectedColor is the single writer
          var singleColorParentProduct = singleColor.closest(".grid__item");
          var specificColor = singleColor.dataset.specificColor;
          var mainProductSpecificColor = singleColorParentProduct.querySelector(
            ".card-specific-color"
          );
          if (mainProductSpecificColor) {
            mainProductSpecificColor.innerHTML = specificColor;
          }

          var mainProductQuickaddBtn = singleColor
            .closest(".grid__item")
            .querySelector(".mobile-icon_quick_add");
          // if(window.innerWidth < 990 && mainProductQuickaddBtn){
          //   mainProductQuickaddBtn.classList.add('quickadd-disabled');
          // }

          var thisProductGet = singleColor.getAttribute("data-get-product");
          var shop_url = Shopify.shop;
window.__quickaddCache = window.__quickaddCache || {};

const pLink = singleColor.getAttribute("p-link") || "";
const handle = pLink.replace("/products/", "").split("?")[0];
if (!handle) return;

const productQuickaddUrl = `/products/${handle}?view=quickadd`;

const applyQuickAddHTML = (htmlText) => {
  if (window.innerWidth < 990 && mainProductQuickaddBtn) {
    const doc = new DOMParser().parseFromString(htmlText, "text/html");

    const newQuickAdd = doc.querySelector(".card_varinats_width_quick_add");
    const newLabel = doc.querySelector(".target-input")?.dataset?.label;

    const thisProductQuickadd = singleColor
      .closest(".grid__item")
      .querySelector(".card_varinats_width_quick_add");

    if (thisProductQuickadd && newQuickAdd) {
      thisProductQuickadd.innerHTML = newQuickAdd.innerHTML;
    }

    const colorLabelInput = singleColor
      .closest(".color_swatch_wraper")
      ?.querySelector(".varinats_check_input_color");

    if (colorLabelInput && newLabel) {
      colorLabelInput.setAttribute("data-label", newLabel);
    }

    // quickAddSizeInputsFunction(); // disabled — function was never defined (audit H1)
  }
};

if (window.__quickaddCache[handle]) {
  applyQuickAddHTML(window.__quickaddCache[handle]);
} else {
  fetch(productQuickaddUrl, { cache: "force-cache" })
    .then((res) => res.text())
    .then((html) => {
      window.__quickaddCache[handle] = html;
      applyQuickAddHTML(html);
    })
    .catch(() => {});
}
          if (
            singleColor
              .closest(".grid__item")
              .querySelector(".card__inner")
              .classList.contains("inner-slider-enabled")
          ) {
            var is_swiper = true;
          } else {
            var is_swiper = false;
          }

          if (is_swiper == true) {
            var mainProductImages =
              singleColor.closest(".grid__item").querySelector(".slide_imgs") ||
              singleColor
                .closest(".grid__item")
                .querySelector(".slide_imgs-swiper");
          } else if (
            singleColor
              .closest(".grid__item")
              .querySelector(".slide_imgs-swiper")
          ) {
            var mainProductImages =
              singleColor.closest(".grid__item").querySelector(".slide_imgs") ||
              singleColor
                .closest(".grid__item")
                .querySelector(".slide_imgs-swiper");
          }

          var selectedColorImages = singleColor.querySelector(
            ".selected-color-images .selcted_slide_imgs-wrapper"
          );
          var selectedColorSize = singleColor.querySelector(
            ".metafield-products-sizes"
          );
          var mainProductPrice = singleColor
            .closest(".grid__item")
            .querySelector(".card-product-price");
          var mainProductBadges = singleColor
            .closest(".grid__item")
            .querySelector(".card-product-badges");
          if (singleColor.classList.contains("one-product-color") == false) {
            var singleColorPrice = singleColor.querySelector(
              ".metafield-product-price"
            ).innerHTML;
            var selectedColorVariantSelect = singleColor.querySelector(
              ".metafield-product-options"
            ).innerHTML;
            var singleColorBadges = singleColor.querySelector(
              ".metafield-product-badges"
            ).innerHTML;
            var SelectedSizeData = selectedColorSize.innerHTML;
            var mainProductSizes = singleColor
              .closest(".grid__item")
              .querySelector(".main-product-sizes");
            mainProductSizes.innerHTML = SelectedSizeData;
            mainProductBadges.innerHTML = singleColorBadges;

            // Toggle SOLD OUT badge based on the selected color/product availability
            (function () {
              const availableStr = singleColor.dataset.available;
              let isAvailable = true;

              if (availableStr !== undefined) {
                isAvailable = availableStr === "true";
              } else if (singleColor.dataset.qty !== undefined) {
                const qty = parseInt(singleColor.dataset.qty, 10);
                if (!Number.isNaN(qty)) isAvailable = qty > 0;
              }

              const soldoutBadges = singleColorParentProduct.querySelectorAll(".js-soldout-badge");
              soldoutBadges.forEach((el) => el.classList.toggle("hidden", isAvailable));
            })();

            mainProductPrice.innerHTML = singleColorPrice;
            var mainProductVariantSelect = singleColor
              .closest(".grid__item")
              .querySelector(".main_variants_color_wraper_card");
            mainProductVariantSelect.innerHTML = selectedColorVariantSelect;
          }
          singleColor.classList.add("active_color");
          var pColorImg = singleColor.getAttribute("p-img");
          var pTitle = singleColor.getAttribute("data-title");
          var mainImg = singleColor
            .closest(".grid__item")
            .querySelector(".main_p_img");
          var mainProductLinks = singleColor
            .closest(".grid__item")
            .querySelectorAll(".main-product-link");
          mainProductLinks.forEach(function (singleLink) {
            singleLink.href = pLink;
          });
          mainImg.src = pColorImg;
          mainImg.srcset = pColorImg;

          if (is_swiper == true) {
            mainProductImages.innerHTML = "";
            mainProductImages.innerHTML = selectedColorImages.innerHTML;

            try {
  const card =
  singleColor.closest(".card-wrapper") ||
  singleColor.closest(".product-card-wrapper");

  if (card) {
    card.dataset.needsSwiperInit = "1";

    if (typeof window.__CollectionDestroyCardSwiper === "function") {
      window.__CollectionDestroyCardSwiper(card);
    }
    if (typeof window.__CollectionInitCardSwiper === "function") {
      window.__CollectionInitCardSwiper(card);
    } else if (typeof window.observeAllCards === "function") {
      window.observeAllCards();
    }
  }
} catch (e) {}
            
            var thisCheckSlider = singleColor
              .closest(".product-card-wrapper")
              .querySelector(".slide_imgs-swiper");
            if (thisCheckSlider) {
              // setTimeout(function(){},1000)
              // swiper.destroy(true,true);
            }
            var thisItemScroller = singleColor
              .closest(".grid__item")
              .querySelector(".swiper-scrollbar");
            var colorItemScroller =
              singleColor.querySelector(".swiper-scrollbar");
            setTimeout(function () {
              if (thisItemScroller) {
                thisItemScroller.style.opacity = "0.7";
                colorItemScroller.style.opacity = "0.7";
                thisItemScroller.querySelector(
                  ".swiper-scrollbar-drag"
                ).style.background = "rgba(0,0,0,0.5)";
                // colorItemScroller.querySelector('.swiper-scrollbar-drag').style.background = 'rgba(0,0,0,0.5)';
                setTimeout(function () {
                  thisItemScroller.style.opacity = "0";
                  colorItemScroller.style.opacity = "0";
                }, 2000);
              }
            }, 100);
          }

          // productQuickAdd();
          pColors.forEach(function (unactiveColor) {
            if (unactiveColor !== singleColor) {
              unactiveColor.classList.remove("active_color");
            }
          });

          var mainCardLinks = singleColor
            .closest(".grid__item")
            .querySelectorAll(".card-product-link");
          if (mainCardLinks) {
            mainCardLinks.forEach((mainCardLink) => {
              mainCardLink.setAttribute("href", pLink);
              mainCardLink.textContent = pTitle;
            });
          }

          var singleColorProductColor = singleColor.dataset.color;
          singleColor
            .closest(".color_swatch_wraper")
            .querySelector(".color_variants:checked")
            .setAttribute("data-label", singleColorProductColor);

          // quickAddSizeInputsFunction(); // disabled — function was never defined (audit H1)

          if (screen.width < 1025) {
            var thisProductSlickDots = singleColor
              .closest(".product-card-wrapper")
              .querySelector(".slick-dots");
            $(".slick-dots").css("opacity", "0");
            if (thisProductSlickDots) {
              thisProductSlickDots.style.opacity = "0.7";

              setTimeout(function () {
                thisProductSlickDots.style.opacity = "0";
              }, 900);
            }

          }
        });
      });
    });
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 150);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  // static setListeners() {
  //   const onHistoryChange = (event) => {
  //     const searchParams = event.state
  //       ? event.state.searchParams
  //       : FacetFiltersForm.searchParamsInitial;
  //     if (searchParams === FacetFiltersForm.searchParamsPrev) return;
  //     FacetFiltersForm.renderPage(searchParams, null, false);
  //   };
  //   window.addEventListener("popstate", onHistoryChange);
  // }
  // New code ITG
  static setListeners() {
    const onHistoryChange = (event) => {
      if (event.state && event.state.url && !event.state.searchParams) {
        const currentParamsObj = new URLSearchParams(window.location.search);
        const prevParamsObj = new URLSearchParams(FacetFiltersForm.searchParamsPrev);
        
        currentParamsObj.delete('page');
        prevParamsObj.delete('page');
        
        const currentSorted = [...currentParamsObj.entries()].sort().toString();
        const prevSorted = [...prevParamsObj.entries()].sort().toString();
        
        if (currentSorted === prevSorted) {
          FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
          return;
        }
      }
      
      const searchParams = event.state && event.state.searchParams
        ? event.state.searchParams
        : window.location.search.slice(1);
      
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  } 



  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        // initializeSlickSlider();
        newSorting();
        // productQuickAdd();
        // document.querySelectorAll(".main-product-link.swiper-slide img").forEach(element => {
        //   pinchZoom(element);
        // });
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    // initializeSlickSlider();
    newSorting();
    // productQuickAdd();
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
    updateActiveFilterLabelsDesk();
    updateActiveFilterLabels();
    colorVariantSwatches();

    try {
  if (typeof window.observeAllCards === "function") window.observeAllCards();

  setTimeout(function () {
    if (typeof window.__CollectionInitCardSwiper !== "function") return;
    const buffer = 300;

    document.querySelectorAll("#product-grid .card-wrapper").forEach(function (card) {
      const r = card.getBoundingClientRect();
      const inRange = r.top < (window.innerHeight + buffer) && r.bottom > -buffer;
      if (inRange) window.__CollectionInitCardSwiper(card);
    });
  }, 0);
} catch (e) {}
    bindSlideDotsEvents();
    if (typeof window.__paginationAttachLinks === 'function') window.__paginationAttachLinks(); // audit M5 — re-bind AJAX pagination after filter render
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
    // updateActiveFilterLabelsDesk();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
    // updateActiveFilterLabelsDesk();
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
    // updateActiveFilterLabelsDesk();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
    // updateActiveFilterLabelsDesk();
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

onSubmitForm(searchParams, event) {
  FacetFiltersForm.renderPage(searchParams, event);
}

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
    // updateActiveFilterLabelsDesk();
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

// desktop filters active values display
var filterWrapperDesk = document.getElementById("FacetsWrapperDesktop");
if (filterWrapperDesk) {
  let filterCountDesk = filterWrapperDesk.querySelector(
    ".desk-active-filter-count"
  );
  let clearAllDesk = filterWrapperDesk.querySelector(".desk-clear-filters");

  function updateActiveFilterLabelsDesk() {
    let checkedFiltersDesk = filterWrapperDesk.querySelectorAll(
      ".desk-filter-input:checked"
    );
    let activeValuesDesk = [];

    checkedFiltersDesk.forEach(function (input) {
      let activeValueDesk = input.getAttribute("active-value");
      if (activeValueDesk) {
        activeValuesDesk.push(activeValueDesk);
      }
    });

    filterWrapperDesk
      .querySelectorAll(".desk-active-filter-label")
      .forEach(function (label) {
        let parentDetail = label.closest(".desk-filter-details");
        if (parentDetail) {
          let relatedInputs = parentDetail.querySelectorAll(
            ".desk-filter-input:checked"
          );
          let relatedValues = [];
          relatedInputs.forEach(function (input) {
            let activeValueDesk = input.getAttribute("active-value");
            if (activeValueDesk) {
              relatedValues.push(activeValueDesk);
            }
          });
          label.textContent = relatedValues.join(", ");
        }
      });

    if (activeValuesDesk.length > 0) {
      filterCountDesk.innerHTML = "(" + activeValuesDesk.length + ")";
      clearAllDesk.classList.remove("hidden");
    } else {
      filterCountDesk.innerHTML = "";
      clearAllDesk.classList.add("hidden");
    }
  }

  let inputFiltersDesk =
    filterWrapperDesk.querySelectorAll(".desk-filter-input");
  inputFiltersDesk.forEach(function (input) {
    input.addEventListener("change", function () {
      updateActiveFilterLabelsDesk();
    });
  });
  updateActiveFilterLabelsDesk();
}

// Mobile Filters Count
let filterWrapper = document.getElementById("FacetFiltersFormMobile");
if (filterWrapper) {
  let filterCount = filterWrapper.querySelector(".mobile-active-filter-count");
  let clearAll = filterWrapper.querySelector(".mobile-clear-filters");

  function updateActiveFilterLabels() {
    let checkedFilters = filterWrapper.querySelectorAll(
      ".mobile-filter-input:checked"
    );
    let activeValues = [];

    checkedFilters.forEach(function (input) {
      let activeValue = input.getAttribute("active-value");
      if (activeValue) {
        activeValues.push(activeValue);
      }
    });

    filterWrapper
      .querySelectorAll(".mbl-active-filter-label")
      .forEach(function (label) {
        let parentDetail = label.closest(".mobile-filter-details");
        let sortparent = label.closest(".mobile-filter-details-sort");

        if (parentDetail) {
          let relatedInputs = parentDetail.querySelectorAll(
            ".mobile-filter-input:checked"
          );
          let relatedValues = [];

          relatedInputs.forEach(function (input) {
            let activeValue = input.getAttribute("active-value");

            // Apply "sort_by" filtering only for elements inside "sortparent"
            if (sortparent) {
              if (window.location.href.includes("sort_by") && activeValue) {
                relatedValues.push(activeValue);
              }
            } else {
              // Normal behavior for other filters
              if (activeValue) {
                relatedValues.push(activeValue);
              }
            }
          });

          label.textContent = relatedValues.join(", ");
        }
      });

    if (activeValues.length > 0) {
      filterCount.innerHTML = "(" + activeValues.length + ")";
      clearAll.classList.remove("hidden");
    } else {
      filterCount.innerHTML = "";
      clearAll.classList.add("hidden");
    }
  }
  let inputFilters = filterWrapper.querySelectorAll(".mobile-filter-input");
  inputFilters.forEach(function (input) {
    input.addEventListener("change", function () {
      updateActiveFilterLabels();
    });
  });
  updateActiveFilterLabels();
}

var stickyFilters =
  document.querySelector("aside#main-collection-filters") ||
  document.querySelector("aside#main-search-filters");

if (stickyFilters) {
  const threshold =
    parseFloat(stickyFilters.getAttribute("data-sticky")) || 0;
  const hideThreshold =
    parseFloat(stickyFilters.getAttribute("data-hide-threshold")) || 0;
  let isSticky = false;

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  let previousScrollPosition = window.pageYOffset;
  let initialScrollPosition = previousScrollPosition;
  let lastDirection = null;

  const handleScroll = () => {
    const currentScrollPosition = window.pageYOffset;

    let direction = null;
    if (currentScrollPosition > previousScrollPosition) {
      direction = "down";
    } else if (currentScrollPosition < previousScrollPosition) {
      direction = "up";
    } else {
      direction = lastDirection;
    }

    // when direction changes, reset the starting point
    if (direction && direction !== lastDirection) {
      initialScrollPosition = previousScrollPosition;
    }

    const scrollDistance = Math.abs(
      currentScrollPosition - initialScrollPosition
    );
    const scrollPercentage = (scrollDistance / window.innerHeight) * 100;

    // always turn off sticky near the top
    if (currentScrollPosition <= 190) {
      stickyFilters.classList.remove("sticky");
      isSticky = false;
    } else {
      if (direction === "up") {
        // scrolling up: turn sticky on after threshold
        if (!isSticky && scrollPercentage > threshold) {
          stickyFilters.classList.add("sticky");
          isSticky = true;
        }
      } else if (direction === "down") {
        // scrolling down: hide after hideThreshold
        if (isSticky && scrollPercentage > hideThreshold) {
          stickyFilters.classList.remove("sticky");
          isSticky = false;
        }
      }
    }

    previousScrollPosition = currentScrollPosition;
    lastDirection = direction;
  };

  window.addEventListener("scroll", debounce(handleScroll, 80));
}

function bindSlideDotsEvents() {
  // audit H5 — emptied: slick carousel is not loaded and .slick-dots never exists in the markup,
  // so these jQuery handlers could never fire. Kept as a no-op because it is still called
  // after sort and after filter renders. This was the last live jQuery usage in the theme.
}